import { render, staticRenderFns } from "./vipMessage.vue?vue&type=template&id=3b488782&scoped=true&"
import script from "./vipMessage.vue?vue&type=script&lang=js&"
export * from "./vipMessage.vue?vue&type=script&lang=js&"
import style0 from "./vipMessage.vue?vue&type=style&index=0&id=3b488782&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b488782",
  null
  
)

export default component.exports